import { Player } from '@lottiefiles/react-lottie-player';
import { useHistory } from "react-router-dom";
import Footer from './Footer';
import Header from './Header';
function NoMatch() {
  const history = useHistory();
  return (<>
    <Header></Header>
    <div className="back-profilazione" style={{ display: 'flex', flexDirection: 'column', width: 'unset' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Player
          autoplay
          loop
          src="https://assets3.lottiefiles.com/private_files/lf30_9pjelogw.json"
          style={{ height: '100%', width: '100%' }}
        >
        </Player>
        <h1>Non troviamo quello che stai cercando</h1>
        <h3>Potresti aver inserito un indirizzo errato, controlla il link, oppure torna alla home.</h3>


      </div><button className="button margin-top-min" style={{ marginTop: '20px', width: '200px', alignSelf: 'center' }} onClick={() => history.push('/')}>Torna alla home</button>
    </div>
    <Footer></Footer>
  </>);
}

export default NoMatch;